<select [(ngModel)]="count" (change)="change()">
  <option value="0">0</option>
  <option value="1">1</option>
  <option value="2">2</option>
  <option value="3">3以上</option>
</select>
